import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import MusicToggle from './components/MusicToggle';
import WineSection from './components/WineSection';
import Cat from './components/Cat';
import Achievements from './components/Achievements';
import Game from './components/Game';
import FlappySteven from './components/FlappySteven';
import MatchingGame from './components/MatchingGame';
import PhotoBooth from './components/PhotoBooth';
import ComplimentGenerator from './components/ComplimentGenerator';
import SecretButton from './components/SecretButton';

function App() {
  const [farts, setFarts] = useState([]);
  const [sparkles, setSparkles] = useState([]);
  const [explosionParticles, setExplosionParticles] = useState([]);

  // Cleanup particles
  useEffect(() => {
    const cleanup = setInterval(() => {
      setFarts(prev => prev.filter(f => Date.now() - f.timestamp < 3000));
      setSparkles(prev => prev.filter(s => Date.now() - s.timestamp < 1000));
      setExplosionParticles(prev => prev.filter(e => Date.now() - e.timestamp < 2000));
    }, 500);

    return () => clearInterval(cleanup);
  }, []);

  // Mouse sparkle effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      if (Math.random() < 0.1) {
        setSparkles(prev => [...prev, {
          id: Date.now() + Math.random(),
          x: e.clientX,
          y: e.clientY,
          timestamp: Date.now()
        }]);
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const createFart = (x, y) => {
    const fartCount = Math.floor(Math.random() * 6) + 3;
    const newFarts = [];

    for (let i = 0; i < fartCount; i++) {
      const angle = (Math.PI * 2 * i) / fartCount;
      const distance = Math.random() * 300 + 200;
      const tx = Math.cos(angle) * distance;
      const ty = Math.sin(angle) * distance;
      const rotation = Math.random() * 720 + 360;

      newFarts.push({
        id: Date.now() + i,
        x,
        y,
        tx,
        ty,
        rotation,
        timestamp: Date.now()
      });
    }

    setFarts(prev => [...prev, ...newFarts]);
  };

  const activateSecret = () => {
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;
    const newExplosions = [];

    for (let i = 0; i < 100; i++) {
      setTimeout(() => {
        const angle = (Math.PI * 2 * i) / 100;
        const distance = Math.random() * 400 + 200;
        const sx = Math.cos(angle) * distance;
        const sy = Math.sin(angle) * distance;

        newExplosions.push({
          id: Date.now() + i,
          x: centerX,
          y: centerY,
          sx,
          sy,
          timestamp: Date.now()
        });
      }, i * 10);
    }

    setTimeout(() => {
      setExplosionParticles(prev => [...prev, ...newExplosions]);
    }, 0);
  };

  // Background faces - useMemo to prevent re-renders
  const backgroundFaces = React.useMemo(() => 
    Array.from({ length: 15 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      animationDelay: Math.random() * 20,
      animationDuration: 15 + Math.random() * 10,
      image: i % 2 === 0 ? '/frolke.jpg' : '/frolke2.jpg'
    })), []
  );

  return (
    <div className="App">
      {/* Background Effects */}
      {backgroundFaces.map(face => (
        <div
          key={face.id}
          className="background-face"
          style={{
            left: `${face.left}%`,
            top: `${face.top}%`,
            animationDelay: `${face.animationDelay}s`,
            animationDuration: `${face.animationDuration}s`,
            backgroundImage: `url(${face.image})`,
            willChange: 'transform'
          }}
        />
      ))}

      {sparkles.map(sparkle => (
        <div
          key={sparkle.id}
          className="sparkle"
          style={{
            left: `${sparkle.x}px`,
            top: `${sparkle.y}px`
          }}
        />
      ))}

      {farts.map(fart => (
        <div
          key={fart.id}
          className="fart"
          style={{
            left: `${fart.x}px`,
            top: `${fart.y}px`,
            '--tx': `${fart.tx}px`,
            '--ty': `${fart.ty}px`,
            '--r': `${fart.rotation}deg`
          }}
        />
      ))}

      {explosionParticles.map(particle => (
        <div
          key={particle.id}
          className="steven-particle"
          style={{
            left: `${particle.x}px`,
            top: `${particle.y}px`,
            '--sx': `${particle.sx}px`,
            '--sy': `${particle.sy}px`
          }}
        />
      ))}

      {/* Main Content */}
      <Header />
      <MusicToggle />
      <Cat onFart={createFart} />
      <WineSection />
      <Achievements />
      <Game />
      <FlappySteven />
      <MatchingGame />
      <PhotoBooth />
      <ComplimentGenerator />
      <SecretButton onActivate={activateSecret} />

      {/* Footer */}
      <div className="footer">
        <p>Made with ❤️ and 🍷 for the legendary Steven Frolke!</p>
        <p>© 2024 Steven Frolke Fan Club</p>
      </div>
    </div>
  );
}

export default App;
